import React from "react";
import FieldLabel from "./ui/FieldLabel";

const NativeInput = React.forwardRef(function NativeInput(
  {
    label,
    required = false,
    tooltip,
    id,
    className = "",
    wrapperClass = "",
    invalid = false,
    feedback = "",
    type = "text",
    ...rest
  },
  ref
) {
  const fieldClass = ["oh-field", wrapperClass, invalid ? "oh-field--invalid" : ""]
    .filter(Boolean)
    .join(" ");

  const inputClass = [
    "oh-field__control",
    "form-control",
    className,
    invalid ? "is-invalid" : "",
  ]
    .filter(Boolean)
    .join(" ");

  const inputId = id || rest.name;

  const renderLabel = () => {
    if (!label) return null;
    if (typeof label === "string") {
      return (
        <FieldLabel htmlFor={inputId} required={required} tooltip={tooltip}>
          {label}
        </FieldLabel>
      );
    }
    return <label className="oh-field__label form-label">{label}</label>;
  };

  return (
    <div className={fieldClass}>
      {renderLabel()}
      <input
        ref={ref}
        id={inputId}
        type={type}
        className={inputClass}
        {...rest}
        aria-invalid={invalid ? "true" : "false"}
      />
      <div
        className="oh-field__error invalid-feedback"
        role={invalid ? "alert" : undefined}
      >
        {feedback || ""}
      </div>
    </div>
  );
});

export default NativeInput;
